﻿import {ChestItem} from "../../Data/GameData";
import {Roulette} from "../Tools/Roulette/Roulette";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {Core} from "../../Base/Core";

const PREFS_FIRST_REWARD = "43v89netyc8nert3cn834crt";

export class UIChestReward extends UICommonPopup {
    get FirstRewardTaken() {
        return PlayerPrefs.HasKey(PREFS_FIRST_REWARD);
    }

    set FirstRewardTaken(value) {
        if (value) PlayerPrefs.SetInt(PREFS_FIRST_REWARD, 1);
        else PlayerPrefs.DeleteKey(PREFS_FIRST_REWARD);
    }

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("chest_open_title"),
        });

        this.onRouletteFinished = this.onRouletteFinished.bind(this);

        this.okBtn = this.content.addChild(
            new UINineSliceButton("btn-green", {
                label: Core.Localizator.Get("ok"),
            })
        );
        this.spinButton = this.content.addChild(
            new UINineSliceButton("btn-green", {
                label: Core.Localizator.Get("chest_open_spin"),
            })
        );
        this.roulette = this.content.addChild(new Roulette());
        this.targetReward = new ChestItem();

        this.spinButton.on("pointertap", () => {
            // this.roulette.StartSpin();
            this.roulette.run();
            this.spinButton.interactive = false;
            Core.UI.game.chestBtn.SetActive(false);
        });

        this.okBtn.on("pointertap", () => {
            if (this.targetReward) {
                this.targetReward.Take("chest_reward");
                this.FirstRewardTaken = true;
            }
            this.Hide();
        });
    }

    Show() {
        if (this.FirstRewardTaken) {
            this.targetReward = Core.GameData.Chest.GetRandom();
        } else {
            this.targetReward = Core.GameData.Chest.Get(3);
        }

        this.spinButton.interactive = true;
        this.spinButton.SetActive(true);
        this.okBtn.SetActive(false);
        this.roulette.Init(this.targetReward, this.onRouletteFinished);

        super.Show();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 0.8;
        let w = Math.min(viewport.width * 0.95, (viewport.height * 0.6) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.height = contentRect.height * 0.4;
        rect.width = contentRect.width;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.5;

        this.roulette.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.42;
        rect.height = contentRect.height * 0.2;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.spinButton.fitLayout(rect);
        this.okBtn.fitLayout(rect);
    }

    onRouletteFinished() {
        console.log("ROULETTE FINISHED", this.targetReward);
        this.spinButton.SetActive(false);
        this.okBtn.SetActive(true);
    }
}
